/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"

const useComponentResizeFinished = elementRef => {
  const instantiateGlobalObserver = () => {
    window.asyncComponentResizeObserver = new ResizeObserver(
      (entries, observer) => {
        let targetElement = null
        for (let entry of entries) {
          targetElement = entry.target
          if (entry.contentRect.height >= 150) {
            const asyncComponentFinishedEvent = new CustomEvent(
              "asyncComponentFinished",
              {
                detail: {
                  component: targetElement,
                },
              }
            )
            window.dispatchEvent(asyncComponentFinishedEvent)
          }
        }
      }
    )
  }

  useEffect(() => {
    if (window.asyncComponentResizeObserver === undefined) {
      instantiateGlobalObserver()
    }
  }, [])

  useEffect(() => {
    let sectionElem = null
    if (typeof elementRef === "string") {
      sectionElem = document.querySelector(elementRef)
    } else if (
      elementRef.current &&
      elementRef.current !== null &&
      window.asyncComponentResizeObserver
    ) {
      sectionElem = elementRef.current
    }

    if (sectionElem) {
      window.asyncComponentResizeObserver.observe(sectionElem)
    }

    return () => {
      let sectionElem = null
      if (typeof elementRef === "string") {
        sectionElem = document.querySelector(elementRef)
      } else if (
        elementRef.current &&
        elementRef.current !== null &&
        window.asyncComponentResizeObserver
      ) {
        sectionElem = elementRef.current
      }

      if (sectionElem) {
        window.asyncComponentResizeObserver.observe(sectionElem)
      }
    }
  }, [elementRef])
}

export default useComponentResizeFinished
